import { ReportRecord } from '../../../../models/report.model';
import { LovValues } from '../../../../models/template.model';
import { currencyLov, PropertyType, valueWithUomPrefix } from '../us/us.common';
import { map } from 'rxjs/operators';

function getParkingCost(record: ReportRecord, options, parkingCost) {
  return currencyLov(options).pipe(
    map((currencyLOV: LovValues[]) => {
      const value = valueWithUomPrefix(record, PropertyType.Office, parkingCost, currencyLOV);
      return Array.isArray(value) ? value.join(', ') : value;
    })
  );
}

export const emeaParkingCostFunctions = {
  362: {
    // 362 - parking cost (Poland)
    displayFn: getParkingCost,
  },
  381: {
    // 381 - parking cost (Italy)
    displayFn: getParkingCost,
  },
  467: {
    // 467 - parking cost (Finland)
    displayFn: getParkingCost,
  },
  486: {
    // 486 - parking cost (Norway)
    displayFn: getParkingCost,
  },
  448: {
    // 448 - parking cost (Sweden)
    displayFn: getParkingCost,
  },
};
